import { To, useMatch, useResolvedPath } from 'react-router-dom';

// ----------------------------------------------------------------------

export const useMatchLink = (link: To) => {
  const { pathname: path } = useResolvedPath(link);

  return useMatch({ path, end: true });
};
